import * as z from 'zod';

import { Expression } from '../../Expressions/AbstractExpressionEvaluator';

const UpdateLoanStatusToREOAction = z.object({
  type: z.literal('updateLoanStatusToREO'),
  processedDate: Expression('plainDate'),
});

export type OnActivateAction = z.infer<typeof OnActivateAction>;
export const OnActivateAction = z.discriminatedUnion('type', [UpdateLoanStatusToREOAction]);

export type OnCompleteAction = z.infer<typeof OnCompleteAction>;
export const OnCompleteAction = z.discriminatedUnion('type', [UpdateLoanStatusToREOAction]);
